export default "__VITE_ASSET__BrglyQTb__"